module.exports = __webpack_public_path__ + "img/review.2c63e695.svg";